/* FM Article — Table of Contents builder (08-Jun-2026)
 *
 * Scans `.fm-art__body` for H2 elements, assigns slug-based anchor IDs
 * to each, then populates `#fm-art-toc-list` with numbered links.
 * The ToC `<nav>` starts with `hidden` — we remove it here only when
 * there are 2+ headings (a single-heading ToC adds noise without value).
 *
 * Smooth-scroll on click is handled by the native `scroll-behavior: smooth`
 * on `html` (set in site-wide CSS) — no extra JS needed.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var body   = document.querySelector('.fm-art__body');
    var toc    = document.getElementById('fm-art-toc');
    var list   = document.getElementById('fm-art-toc-list');

    if (!body || !toc || !list) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (headings.length < 2) return;   /* hide for single-heading articles */

    headings.forEach(function (h, i) {
      /* Build a slug from the heading text, falling back to an index. */
      var slug = (h.textContent || '').trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .substring(0, 60)
        || ('section-' + (i + 1));

      /* Ensure uniqueness in the unlikely event two headings share text. */
      if (document.getElementById(slug)) {
        slug = slug + '-' + (i + 1);
      }

      h.id = slug;

      var li   = document.createElement('li');
      li.className = 'fm-art__toc-item';

      var a    = document.createElement('a');
      a.href   = '#' + slug;
      a.className = 'fm-art__toc-link';
      a.textContent = h.textContent.trim();

      li.appendChild(a);
      list.appendChild(li);
    });

    /* Reveal the nav now that it has content. */
    toc.removeAttribute('hidden');
  });
})();
